import axios from 'axios';
import { currentSession } from 'aws-auth-lib';
import { ensureAuthSuccess } from '../utils/access';

export const api = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    headers: { 'Content-Type': 'application/json' }
});

let accessRequests = new AbortController();

// Abort all requests belonging to the previous access context.
export const setPanelRole = (uuid) => {
    if (uuid && api.defaults.headers.common['CHEART-ROLE'] === uuid) return;
    accessRequests.abort();
    accessRequests = new AbortController();
    if (uuid) api.defaults.headers.common['CHEART-ROLE'] = uuid;
    else delete api.defaults.headers.common['CHEART-ROLE'];
};

api.interceptors.request.use(async (config) => {
    const requestScope = accessRequests;
    config.signal = requestScope.signal;
    const requestedRole = config.headers['CHEART-ROLE'];
    const activeRole = api.defaults.headers.common['CHEART-ROLE'];
    if (requestedRole && requestedRole !== activeRole) {
        throw new axios.CanceledError('ACCESS_CONTEXT_CHANGED');
    }
    const session = ensureAuthSuccess(await currentSession());
    if (requestScope.signal.aborted) throw new axios.CanceledError('ACCESS_CONTEXT_CHANGED');
    const token = session?.tokens?.idToken?.toString();
    if (!token) throw new Error('SESSION_UNAVAILABLE');
    config.headers['AUTH-TOKEN-AWS'] = token;
    return config;
});

export const getUser = async () => {
    const response = await api.get('/cheart/user');
    return response.data;
};
